import { useSyncExternalStore } from 'react';

export const COLLABORATOR_SYNC_ERROR_SNACKBAR_ID = 'sync-to-platform-error';

type SyncErrorListener = () => void;

let collaboratorSyncError: string | null = null;
const syncErrorListeners = new Set<SyncErrorListener>();

const notifySyncErrorListeners = () => {
  syncErrorListeners.forEach((listener) => listener());
};

const subscribeToCollaboratorSyncError = (listener: SyncErrorListener) => {
  syncErrorListeners.add(listener);

  return () => {
    syncErrorListeners.delete(listener);
  };
};

const getCollaboratorSyncErrorSnapshot = () => collaboratorSyncError;

export const setCollaboratorSyncError = (message: string | null) => {
  if (collaboratorSyncError === message) {
    return;
  }

  collaboratorSyncError = message;
  notifySyncErrorListeners();
};

export const useCollaboratorSyncError = () =>
  useSyncExternalStore(subscribeToCollaboratorSyncError, getCollaboratorSyncErrorSnapshot, getCollaboratorSyncErrorSnapshot);
